import React from 'react';
import { TableRow, TableCell, Tooltip, Typography } from '@material-ui/core';
import RocketLaunchIcon from '@material-ui/icons/FlightTakeoff';
import EditIcon from '@material-ui/icons/Edit';
import Badge from '../../shared_components/components/Badge';
import { DRAFT_STATUS_COLOR } from '../constants';
import { formatTrackerDate } from '../utils';
import { TEXT, TruncatedText } from '../../shared_components';

const DraftRow = ({ plan, onLaunch, onEdit }) => (
  <TableRow hover>
    <TableCell><Typography variant="body2" style={{ fontWeight: 600, color: TEXT.primary }}><TruncatedText text={plan?.name} maxWidth={240} /></Typography></TableCell>
    <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}><TruncatedText text={plan?.lessor?.name} maxWidth={160} /></Typography></TableCell>
    {/* <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}>{plan?.inspection_type?.label || plan?.inspection_type?.name}</Typography></TableCell> */}
    <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}>{plan?.asset_count}</Typography></TableCell>
    <TableCell><Typography variant="body2" style={{ color: TEXT.secondary }}>{formatTrackerDate(plan?.planned_start_date)}</Typography></TableCell>
    <TableCell><Badge label={plan?.status?.label} color={DRAFT_STATUS_COLOR[plan?.status?.label]} /></TableCell>
    <TableCell align="right">
      <Tooltip title="Launch" arrow>
        <RocketLaunchIcon color="primary" fontSize="small" style={{ cursor: 'pointer', marginRight: 10 }} onClick={() => onLaunch(plan)} />
      </Tooltip>
      <Tooltip title="Edit" arrow>
        <EditIcon color="primary" fontSize="small" style={{ cursor: 'pointer' }} onClick={() => onEdit(plan)} />
      </Tooltip>
    </TableCell>
  </TableRow>
);

export default DraftRow;
